import { render, staticRenderFns } from "./AsideProjects.vue?vue&type=template&id=178da110&scoped=true&"
import script from "./AsideProjects.vue?vue&type=script&lang=js&"
export * from "./AsideProjects.vue?vue&type=script&lang=js&"
import style0 from "./AsideProjects.vue?vue&type=style&index=0&id=178da110&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178da110",
  null
  
)

export default component.exports